import { render, staticRenderFns } from "./EntityTypeEdit.vue?vue&type=template&id=45faf4bd"
import script from "./EntityTypeEdit.vue?vue&type=script&lang=js"
export * from "./EntityTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports